module.exports = __webpack_public_path__ + "static/media/14.96ebdaf4.jpg";